import type { ApiResponse, PaginatedResponse, Product } from '@/types/api';

import { api } from './api';

export const productService = {
  list: async (params?: Record<string, unknown> & { userId?: number }) => {
    const queryParams: Record<string, unknown> = { ...params };
    if (queryParams.userId) {
      queryParams.userId = queryParams.userId;
    }
    const response = await api.get<PaginatedResponse<Product>>('/products', { params: queryParams });
    return response.data;
  },
  create: async (payload: Partial<Product>) => {
    const response = await api.post<ApiResponse<Product>>('/products', payload);
    return response.data.data;
  },
  update: async (id: number, payload: Partial<Product>) => {
    const response = await api.put<ApiResponse<Product>>(`/products/${id}`, payload);
    return response.data.data;
  },
  remove: async (id: number) => {
    await api.delete(`/products/${id}`);
  },
  activate: async (id: number) => {
    await api.put(`/products/${id}/activate`);
  },
};
